var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('ChartHistogram',{attrs:{"size":"12","offset":"0","title":"Total Tested","chartType":"totalTested"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }